module.exports = __webpack_public_path__ + "static/404-072a6293170616d3a5d0eede11495ae1.png";